export const profilActionTypes = {
	UPDATE_PROFIL: "UPDATE_PROFIL"
};
